"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitErrorFromLogIfNeeded = exports.submitItem = void 0;
const axios_1 = require("axios");
const log_utils_1 = require("./log.utils");
const submitItem = async ({ sender, config, error, message, level, context, channelName, }) => {
    if (!config.apiKeys.reportingApiKey) {
        console.warn('Cannot post error. Errors API key is missing');
    }
    try {
        const { data = {} } = await axios_1.default.post(`${config.reportingApi}/${error ? 'error' : 'message'}`, {
            error,
            message,
            level,
            sender,
            date: format(new Date()),
            env: config.stage,
            context: JSON.stringify(context),
            timestamp: Date.now(),
            channelName: channelName || '',
        }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: config.apiKeys.reportingApiKey,
            },
        });
        return data;
    }
    catch (error) {
        (0, log_utils_1.logError)(error);
    }
};
exports.submitItem = submitItem;
function format(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
async function submitErrorFromLogIfNeeded({ context, severity, payload, customSubmitError, }) {
    if (severity === 'warning' ||
        severity === 'error' ||
        severity === 'critical') {
        const errorText = typeof payload === 'object'
            ? JSON.stringify(payload, null, 2)
            : payload;
        await customSubmitError({
            error: errorText,
            level: severity === 'critical'
                ? 'critical'
                : severity === 'error'
                    ? 'normal'
                    : 'minor',
            context,
        });
    }
}
exports.submitErrorFromLogIfNeeded = submitErrorFromLogIfNeeded;
